import { Link } from "@tanstack/react-router";

import * as m from "@/paraglide/messages";

export function LandingFooter() {
	return (
		<footer className="bg-foreground px-4 py-12 text-background md:px-12">
			<div className="mx-auto flex max-w-6xl flex-col items-start gap-8 md:flex-row md:items-center md:justify-between">
				<Link to="/" className="flex items-center gap-2">
					<img src="/logo.svg" alt="StudyOS" className="size-6" />
					<span>
						<span className="text-base font-bold">Study</span>
						<span className="text-lg font-medium">OS</span>
					</span>
				</Link>

				<nav className="flex flex-wrap items-center gap-6 text-sm font-semibold text-background/80">
					<Link to="/about" className="hover:text-background">
						{m.landing_footer_features()}
					</Link>
					<Link to="/contact" className="hover:text-background">
						{m.landing_footer_contact()}
					</Link>
					<Link to="/sign-up" className="rounded-full px-4 py-2 hover:text-background">
						{m.landing_footer_startFree()}
					</Link>
				</nav>

				<div className="flex items-center gap-4 text-sm text-background/55">
					<Link to="/privacy" className="hover:text-background">
						{m.landing_footer_privacy()}
					</Link>
					<Link to="/terms" className="hover:text-background">
						{m.landing_footer_terms()}
					</Link>
				</div>
			</div>
			<p className="mx-auto mt-10 max-w-6xl text-center text-xs text-background/40">
				{m.landing_footer_copyright({ year: new Date().getFullYear() })}
			</p>
		</footer>
	);
}
